import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import _ from "lodash";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const BranchBalanceTable = ({ printMode = false }) => {
  const { list, loading } = useSelector((state) => state.branchBalance);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const paidTotal = _.sumBy(list, (r) => Number(r.transferAmount) || 0);
  const receivedTotal = _.sumBy(list, (r) => Number(r.receivedAmount) || 0);
  const balanceTotal = _.sumBy(list, (r) => Number(r.balance) || 0);

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Branch Name", dataIndex: "name" },
    { title: "Branch Address", dataIndex: "branch_address" },
    {
      title: "Paid Amount",
      dataIndex: "transferAmount",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Received Amount",
      dataIndex: "receivedAmount",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      align: "right",
      render: (val) => fmt(val),
    },
  ];

  if (printMode) {
  return (
    <table className="bb-print-table">
      <colgroup>
        <col style={{ width: "6%" }} />
        <col style={{ width: "24%" }} />
        <col style={{ width: "30%" }} />
        <col style={{ width: "13%" }} />
        <col style={{ width: "13%" }} />
        <col style={{ width: "14%" }} />
      </colgroup>

      <tbody>
        <tr className="bb-print-heading">
          <td>No.</td>
          <td>Branch Name</td>
          <td>Branch Address</td>
          <td style={{ textAlign: "right" }}>Paid Amount</td>
          <td style={{ textAlign: "right" }}>Received Amount</td>
          <td style={{ textAlign: "right" }}>Balance</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.branch_id || index}>
            <td>{index + 1}</td>

            <td>{row.name}</td>

            <td>{row.branch_address}</td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.transferAmount)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.receivedAmount)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.balance)}
            </td>
          </tr>
        ))}

        <tr className="bb-print-total">
          <td colSpan={3} style={{ textAlign: "right" }}>
            Grand Total :
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(paidTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(receivedTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(balanceTotal)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(record, idx) => record.branch_id || idx}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={3} align="right">
            <strong>Grand Total :</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={3} align="right">
            <strong>{fmt(paidTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={4} align="right">
            <strong>{fmt(receivedTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5} align="right">
            <strong>{fmt(balanceTotal)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default BranchBalanceTable;
